(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flickity-two-column-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const $imageSlider = $('.owl-carousel-image');
  const $textSlider = $('.owl-carousel-text');

  $imageSlider.owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    smartSpeed: 1500
  });

  $textSlider.owlCarousel({
    items: 1,
    loop: true,
    nav: false,
    dots: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    dotsContainer: '.text-slider-nav',
    smartSpeed: 1500
  });

  // Sync sliders
  $textSlider.on('changed.owl.carousel', function(event) {
    $imageSlider.trigger('to.owl.carousel', [event.item.index, 500, true]);
  });

  $('.image-slider-nav .prev').click(function () {
    $imageSlider.trigger('prev.owl.carousel');
    $textSlider.trigger('prev.owl.carousel');
  });

  $('.image-slider-nav .next').click(function () {
    $imageSlider.trigger('next.owl.carousel');
    $textSlider.trigger('next.owl.carousel');
  });
});

  } catch(e) { console.error(e); }
})();
})();
